<template>
  <header class="site-header" :class="{ 'is-scrolled': scrolled }">
    <div class="topbar">
      <div class="container topbar-inner">
        <span>Professional accounting & business advisory</span>
        <div class="topbar-links">
          <a href="mailto:info@jomass.com">info@jomass.com</a>
          <span class="topbar-divider"></span>
          <a href="tel:+2348000000000">+234 800 000 0000</a>
        </div>
      </div>
    </div>

    <div class="nav-wrap">
      <div class="container nav-inner">
        <router-link class="brand" to="/">
          <span class="brand-mark">J</span>
          <span class="brand-copy">
            <strong>JOMASS</strong>
            <small>ACCOUNTING & BUSINESS CONSULTANTS</small>
          </span>
        </router-link>

        <button class="menu-toggle" type="button" @click="menuOpen = !menuOpen" :aria-expanded="menuOpen">
          <span></span><span></span><span></span>
        </button>

        <nav class="main-nav" :class="{ open: menuOpen }">
          <a href="#home" @click="closeMenu">Home</a>
          <a href="#about" @click="closeMenu">About</a>
          <a href="#services" @click="closeMenu">Services</a>
          <a href="#industries" @click="closeMenu">Industries</a>
          <a href="#insights" @click="closeMenu">Insights</a>
          <a href="#contact" class="nav-cta" @click="closeMenu">Book a Consultation <span>↗</span></a>
        </nav>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'SiteHeader',
  data() {
    return {
      menuOpen: false,
      scrolled: false
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
    this.handleScroll()
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll() {
      this.scrolled = window.scrollY > 20
    },
    closeMenu() {
      this.menuOpen = false
    }
  }
}
</script>